import { useState } from "react";

const GREEN = "#16a34a";
const NAVY = "#132a63";
const COMISION = 80; // una mensualidad por venta
const GOAL_PCT = 0.05; // meta del socio: 5% de su audiencia

const FOLLOWER_OPTS = [
  { v: "<10k", label: "Menos de 10,000", mid: 5000 },
  { v: "10k-25k", label: "10,000 – 25,000", mid: 17500 },
  { v: "25k-50k", label: "25,000 – 50,000", mid: 37500 },
  { v: "50k-100k", label: "50,000 – 100,000", mid: 75000 },
  { v: "+100k", label: "Más de 100,000", mid: 150000 },
];
const midOf = (range) => (FOLLOWER_OPTS.find((o) => o.v === range) || FOLLOWER_OPTS[1]).mid;
const money = (n) => `$${Number(n || 0).toLocaleString("es-MX")}`;

export default function MissionBanner({ variant = "dark", seguidores = null, ventasActuales = null }) {
  const [range, setRange] = useState(seguidores || "50k-100k");
  const dark = variant === "dark";
  const followers = midOf(seguidores || range);
  const goal = Math.round(followers * GOAL_PCT); // clientes meta
  const gananciaMeta = goal * COMISION; // una mensualidad por venta
  const progresoPct = ventasActuales != null && goal > 0
    ? Math.min(100, Math.round((ventasActuales / goal) * 100)) : null;

  const txt = dark ? "#e6ebf5" : NAVY;
  return (
    <div
      data-testid="mission-banner"
      style={{
        background: dark ? "rgba(255,255,255,0.06)" : "#F3F7FF",
        border: `1px solid ${dark ? "rgba(255,255,255,0.15)" : "#dbe4ff"}`,
        borderRadius: 18, padding: "22px 24px", marginBottom: 18,
      }}
    >
      <div style={{ fontSize: 13, fontWeight: 800, letterSpacing: 0.5, color: GREEN, marginBottom: 6 }}>
        🚀 SÉ PARTE DEL MOVIMIENTO
      </div>
      <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: txt }}>
        Somos un grupo de jóvenes demostrando que con <strong>IA</strong> se pueden contratar servicios a
        precios que benefician a todos. Cuando lleguemos a <strong>+10,000 clientes</strong>, un grupo de
        inversionistas nos apoyaría para llevarlo a <strong>Estados Unidos</strong>.{" "}
        <span style={{ color: GREEN, fontWeight: 700 }}>¿No estarías orgulloso de ser parte de esta vanguardia tecnológica?</span>
      </p>

      {/* Meta del socio: 5% de su audiencia */}
      <div
        data-testid="socio-goal"
        style={{ marginTop: 18, background: dark ? "rgba(0,0,0,0.2)" : "white", borderRadius: 14, padding: "16px 18px", border: `1px solid ${dark ? "rgba(255,255,255,0.1)" : "#e2e8f0"}` }}
      >
        <div style={{ fontSize: 13, fontWeight: 800, color: txt, marginBottom: 10 }}>
          🎯 Tu meta: convertir el <span style={{ color: GREEN }}>5%</span> de tu audiencia
        </div>

        {!seguidores && (
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, color: dark ? "#cbd5e1" : "#6b7280", display: "block", marginBottom: 4 }}>¿Cuántos seguidores tienes?</label>
            <select
              data-testid="socio-goal-followers"
              value={range}
              onChange={(e) => setRange(e.target.value)}
              style={{ width: "100%", padding: "9px 11px", borderRadius: 8, border: "1px solid #cbd5e1", fontSize: 14 }}
            >
              {FOLLOWER_OPTS.map((o) => <option key={o.v} value={o.v}>{o.label}</option>)}
            </select>
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div style={box(dark)}>
            <div style={{ fontSize: 11, color: dark ? "#94a3b8" : "#6b7280" }}>Tu meta de clientes</div>
            <div data-testid="socio-goal-clients" style={{ fontSize: 24, fontWeight: 900, color: GREEN }}>{goal.toLocaleString("es-MX")}</div>
          </div>
          <div style={box(dark)}>
            <div style={{ fontSize: 11, color: dark ? "#94a3b8" : "#6b7280" }}>Ganarías (por venta)</div>
            <div data-testid="socio-goal-earnings" style={{ fontSize: 24, fontWeight: 900, color: dark ? "#FFD23F" : NAVY }}>{money(gananciaMeta)}</div>
          </div>
        </div>
        <p style={{ fontSize: 12, color: dark ? "#94a3b8" : "#6b7280", margin: "10px 0 0" }}>
          Una mensualidad (${COMISION}) por cada cliente que se suscribe con tu código — <strong>más una comisión cada vez que renuevan</strong>. Ingreso recurrente.
        </p>

        {progresoPct != null && (
          <div style={{ marginTop: 14 }}>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, fontWeight: 700, color: txt, marginBottom: 5 }}>
              <span data-testid="socio-goal-progress-label">Tu avance: {ventasActuales} / {goal.toLocaleString("es-MX")} clientes</span>
              <span style={{ color: GREEN }}>{progresoPct}%</span>
            </div>
            <div style={{ height: 10, borderRadius: 999, background: dark ? "rgba(255,255,255,0.15)" : "#e2e8f0", overflow: "hidden" }}>
              <div data-testid="socio-goal-progress-bar" style={{ height: "100%", width: `${Math.max(2, progresoPct)}%`, background: `linear-gradient(90deg, ${GREEN}, #7DC242)`, borderRadius: 999, transition: "width 0.6s ease" }} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const box = (dark) => ({
  background: dark ? "rgba(255,255,255,0.05)" : "#F3F7FF",
  borderRadius: 10, padding: "10px 12px", textAlign: "center",
});
